import { ContentStandardLayout } from 'components/Layouts/ContentStandardLayout';
import { TraderPositionsTable } from 'components/TraderPositions';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useStore } from 'store/StoreContext';


export const TraderPositions = () => {
  const { leaderboard } = useStore();
  const { id } = useParams();

  useEffect(() => {
    leaderboard.fetchSelectedFollowersPositions(id);
  }, [leaderboard, id]);

  return (
    <ContentStandardLayout title="Trader positions">
      <TraderPositionsTable />
    </ContentStandardLayout>
  );
};
